import http from '@/utils/services/http'

export default {
  atualizaStatusConsiderarEntidade (idEntidade, status) {
    return http.patch(`/api/lote-entidade/${idEntidade}/alterar-status-considerar`, JSON.stringify({status}))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getEntidadesLote (loteId) {
    return http.get('/api/lote/' + loteId + '/lote-entidade')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  findEntidadeLote (entidadeId) {
    return http.get('/api/lote-entidade/' + entidadeId)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastroEntidadeLote (entidade, idLote, idEntidade) {
    if (idEntidade) {
      return this.atualizacaoEntidadeLote(entidade, idEntidade)
    }
    return http.post(`/api/lote/${idLote}/lote-entidade`, entidade)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacaoEntidadeLote (data, id) {
    return http.patch(`/api/lote-entidade/${id}`, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteEntidadeLote (entidadeId) {
    return http.delete(`/api/lote-entidade/${entidadeId}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  listTipoEntidade (limit, page, filtros) {
    return http.get('/api/tipo-lote-entidade/?page=' + page + '&limit=' + limit + filtros)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastrarTipoEntidade (data, id = null) {
    if (id) {
      return this.update(data, id)
    }
    return http.post('/api/tipo-lote-entidade/', JSON.stringify(data))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  findTipoEntidade (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/tipo-lote-entidade/' + id)
      .then(response => {
        console.log(response)
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  updateTipoEntidade (data, id) {
    return http.patch('/api/tipo-lote-entidade/' + id, JSON.stringify(data))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteTipoEntidade (id) {
    return http.delete('/api/tipo-lote-entidade/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  listAllTipoEntidade () {
    return http.get('/api/tipo-lote-entidade/list')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/leiloes/services/lote-entidade.js